import type { Environment } from '@seddi/scene';
import { type LoadingManager, type WebGLRenderer, PMREMGenerator } from '@seddi/three';
import log from 'loglevel';

import { load } from './environmentLoader';
import type { EnvironmentGfx } from './environmentTypes';
import { ResourceManager } from './resourceManager';

export class EnvironmentsContext extends ResourceManager<EnvironmentGfx> {
  readonly generator: PMREMGenerator;
  readonly manager: LoadingManager;
  readonly renderer: WebGLRenderer;

  constructor(manager: LoadingManager, renderer: WebGLRenderer) {
    super();
    this.manager = manager;
    this.renderer = renderer;
    this.generator = new PMREMGenerator(renderer);
    this.generator.compileEquirectangularShader();
  }

  async loadAsync(desc: Environment): Promise<EnvironmentGfx | undefined> {
    if (this.find(desc.id)) {
      log.warn(`EnvironmentsContext.loadAsync: ${desc.id} is not new.`);
      return undefined;
    }

    const item = this.create(desc.id);
    item.status = 'loading';

    const value = await load(desc, this.manager, this.renderer, this.generator);

    if (!value.texture) {
      return undefined;
    }

    item.status = 'ready';
    item.value = value;

    if (this.onLoad) {
      this.onLoad(desc.id, 'Environment');
    }

    return value;
  }
}
